/**
 * @license Copyright (c) 2014-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor.js';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import AutoImage from '@ckeditor/ckeditor5-image/src/autoimage.js';
import Autosave from '@ckeditor/ckeditor5-autosave/src/autosave.js';
// import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink.js';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote.js';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Code from '@ckeditor/ckeditor5-basic-styles/src/code.js';
import DataFilter from '@ckeditor/ckeditor5-html-support/src/datafilter.js';
import DataSchema from '@ckeditor/ckeditor5-html-support/src/dataschema.js';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import FindAndReplace from '@ckeditor/ckeditor5-find-and-replace/src/findandreplace.js';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor.js';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily.js';
import FontSize from '@ckeditor/ckeditor5-font/src/fontsize.js';
import GeneralHtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport.js';
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import HeadingButtonsUI from '@ckeditor/ckeditor5-heading/src/headingbuttonsui';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight.js';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline.js';
import HtmlComment from '@ckeditor/ckeditor5-html-support/src/htmlcomment.js';
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed.js';
import Image from '@ckeditor/ckeditor5-image/src/imageblock.js';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption.js';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize.js';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload.js';
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert';
import Indent from '@ckeditor/ckeditor5-indent/src/indent.js';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import Link from '@ckeditor/ckeditor5-link/src/link.js';
import List from '@ckeditor/ckeditor5-list/src/list.js';
import ListStyle from '@ckeditor/ckeditor5-list/src/liststyle.js';
import MediaEmbed from '../plugins/MediaNew/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat.js';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting.js';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough.js';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript.js';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript.js';
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableCaption from '@ckeditor/ckeditor5-table/src/tablecaption.js';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation.js';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline.js';
import WordCount from '@ckeditor/ckeditor5-word-count/src/wordcount.js';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';

import Spravka from '../plugins/Spravka/spravka';
import Persona from '../plugins/Persona/Persona';
import SpravkaLeft from '../plugins/SpravkaLeft/spravkaLeft';
import SliderInMaterial from "../plugins/SliderInMaterial/SliderInMaterial";
import UpdateMaterial from "../plugins/updateMaterial/UpdateMaterial";
import Opros from "../plugins/Opros/Opros";
import ContactBlock from "../plugins/ContactBlock/ContactBlock";
import Poll from "../plugins/Test/Poll";
import Forma from "../plugins/Forma/Forma";
import NewsInText from '../plugins/NewsInText/NewsInText';
import NewsInTextTwo from '../plugins/NewsInTextTwo/NewsInTextTwo';
import InsertMedic from "../plugins/InsertMedic/InsertMedic";
import BlockQuoteHard from "../plugins/BlockQuoteHard/BlockQuoteHard";
import NewBlockquote from "../plugins/NewBlockquote/NewBlockquote";
import SmallCaps from '../plugins/smallCaps/small-caps';
import MultiMediaDropDown from '../plugins/DropDownMultiMedia/MultiMediaDropDown';
import DropDownInsert from '../plugins/DropDownInsert/DropDownInsert';
import DropDownPhotoGroup from '../plugins/DropDownPhotoGroup/DropDownPhotoGroup';
import DropDownPhotoGeneral from '../plugins/DropDownPhotoGeneral/DropDownPhotoGeneral';
import TextStylesDropDown from '../plugins/DropDownTextStyles/TextStylesDropDown';
import VrezkaDark from '../plugins/VrezkaDark/VrezkaDark';
import VrezkaLight from '../plugins/VrezkaLight/VrezkaLight';
import PhotoFullWidth from '../plugins/PhotoFullWidth/PhotoFullWidth';
import PhotoDivRight from '../plugins/PhotoDivRight/PhotoDivRight';
import PhotoDivLeft from '../plugins/PhotoDivLeft/PhotoDivLeft';
import TwoPhoto from '../plugins/PhotoGroup/TwoPhoto/TwoPhoto';
import ThreePhoto from '../plugins/PhotoGroup/ThreePhoto/ThreePhoto';
import FourPhoto from '../plugins/PhotoGroup/FourPhoto/FourPhoto';
import FivePhoto from '../plugins/PhotoGroup/FivePhoto/FivePhoto';
import SixPhoto from '../plugins/PhotoGroup/SixPhoto/SixPhoto';
import TwoPhotoGeneral from '../plugins/PhotoGeneralGroup/TwoPhotoGeneral/TwoPhotoGeneral';
import ThreePhotoGeneral from '../plugins/PhotoGeneralGroup/ThreePhotoGeneral/ThreePhotoGeneral';
import FourPhotoGeneral from '../plugins/PhotoGeneralGroup/FourPhotoGeneral/FourPhotoGeneral';
import FivePhotoGeneral from '../plugins/PhotoGeneralGroup/FivePhotoGeneral/FivePhotoGeneral';
import SixPhotoGeneral from '../plugins/PhotoGeneralGroup/SixPhotoGeneral/SixPhotoGeneral';
import CustomDiv from '../plugins/CustomDiv/CustomDiv';
import ImageCustom from '../plugins/ImageCustom/imagecustom';
import AnchorBlock from '../plugins/AnchorBlock/AnchorBlock';
// import AnchorBlock from '../plugins/AnchorBlock/AnchorBlock';


import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import formatTextIcon from '../plugins/icons/formatText.svg';
import imageIcon from "../plugins/icons/icon_normal_text.svg";
import imageIconFoto from "../plugins/icons/icon-fotobank-1.svg";
import imageAnchor from "../plugins/icons/icon_contents.svg";
import imageAnchorAuto from "../plugins/icons/icon_anchor_auto.svg";
import ImageCustomVertical from "../plugins/ImageCustomVertical/imageverticalcustom";


class FormatTextCustom extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add('FormatTextCustom', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Замена кавычек и пробелов',
                icon: imageIcon,
                withText: false,
                tooltip: true
            });

            // Callback executed once the image is clicked.
            view.on('execute', () => {
                var text = editor.getData();
                text = text.replace(/<p>&nbsp;<\/p>/gi, '');
                text = text.replace(/<p><i><strong>&nbsp;<\/strong><\/i><\/p>/gi, '');
                text = text.replace(/<p><strong>&nbsp;<\/strong><\/p>/gi, '');
                text = text.replace(/<p><i>&nbsp;<\/i><\/p>/gi, '');
                text = text.replace(/МОЁ! Online/gi, 'МОЁ!&nbsp;Online');
                text = text.replace(/МОЁ! Плюс/gi, 'МОЁ!&nbsp;Плюс');

                function changeQuotes(text) {
                    var el = document.createElement("DIV");
                    el.innerHTML = text;
                    for (var i = 0, l = el.childNodes.length; i < l; i++) {
                        if ((el.childNodes[i].nodeName == 'P' || el.childNodes[i].nodeName == 'H3' || el.childNodes[i].nodeName == 'H2'
                            || el.childNodes[i].nodeName == 'H4' || el.childNodes[i].nodeName == 'H5') && el.childNodes[i].innerHTML.indexOf('<a') < 0 ) {
                            let one_text = el.childNodes[i].innerHTML
                                .replace(/\x27/g, '\x22')
                                .replace(/(\w)\x22(\w)/g, '$1\x27$2')
                                .replace(/(^)\x22(\s)/g, '$1»$2')
                                .replace(/(^|\s|\()"/g, "$1«")
                                .replace(/&nbsp;/g, " ")
                                .replace(/---/g, "&mdash;")
                                .replace(/--/g, "&mdash;")
                                .replace(/\s-\s/g, " &mdash; ")
                                .replace(/\s‑\s/g, " &mdash; ")
                                .replace(/–/g, "&mdash;")
                                .replace(/>-/g, ">&mdash;")
                                .replace(/-\s/g, "&mdash; ")
                                .replace(/>-\s/g, ">&mdash; ")
                                .replace(/&ndash;/g, "&mdash;")
                                .replace(/\("/g, "(«")
                                .replace(/>"/g, ">«")
                                .replace(/"</g, "»<")
                                .replace(/\s+(а|без|безо|в|во|вне|да|для|до|ее|ещё|еще|и|или|из|изо|или|их|за|к|как|ко|меж|между|на|над|надо|не|ни|но|о|об|обо|от|ото|перед|передо|по|под|подо|пред|предо|при|про|около|с|сквозь|со|то|там|у|уж|что|через|я)\s+/g, " $1&nbsp;")
                                .replace(/"(\;|\!|\?|\:|\.|\,|$|\)|\s)/g, "»$1");
                                // .replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
                            el.childNodes[i].innerHTML = one_text;
                        }
                    }
                    return el.innerHTML;
                }

                editor.setData(changeQuotes(text));

                // editor.setData(text);
            });

            return view;
        });
    }
}

class Editor extends ClassicEditor {
}

class ShowFotoBank extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('showFotoBank', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Загрузить из фотобанка',
                icon: imageIconFoto,
                withText: false,
                tooltip: true
            });

            // Callback executed once the image is clicked.
            view.on('execute', () => {
                editor.model.change(writer => {
                    fotoBankBlock.$refs.fotobank.setType('in_text');
                    $('#fotoBank').modal('show');
                });
            });
            return view;
        });
    }
}

// class ShowAnchorContents extends Plugin {
//     init() {
//         const editor = this.editor;
//
//         editor.ui.componentFactory.add('showAnchorContents', locale => {
//             const view = new ButtonView(locale);
//
//             view.set({
//                 label: 'Открыть содержание',
//                 icon: imageAnchor,
//                 withText: false,
//                 tooltip: true
//             });
//
//             // Callback executed once the image is clicked.
//             view.on('execute', () => {
//                 editor.model.change(writer => {
//                     $('.btnContents').click();
//                 });
//             });
//             return view;
//         });
//     }
// }
function makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

class ShowAnchorContentsAuto extends Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('showAnchorContentsAuto', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Содержание Создать/Редактировать',
                icon: imageAnchorAuto,
                withText: false,
                tooltip: true
            });

            // Callback executed once the image is clicked.
            view.on('execute', () => {
                editor.model.change(writer => {
                    let text = editor.getData();
                    let array = [];
                    var el = document.createElement("DIV");
                    el.innerHTML = text;
                    for (var i = 0, l = el.childNodes.length; i < l; i++) {
                        if (el.childNodes[i].nodeName == 'H2') {
                            var anchor = {};
                            anchor.name = el.childNodes[i].textContent;
                            if (el.childNodes[i].hasAttribute('id')) {
                                anchor.anchor = el.childNodes[i].getAttribute('id');
                                el.childNodes[i].setAttribute('id', anchor.anchor);
                            } else {
                                anchor.anchor = 'text_anchor_' + makeid(8);
                                el.childNodes[i].setAttribute('id', anchor.anchor);
                            }
                            array.push(anchor);
                        }
                    }

                    axios.post(table_of_contents_url, {
                        data: array,
                    }).then(function (){
                        editor.setData(el.innerHTML);
                        $('.btnContents').click();
                    });
                });
            });
            return view;
        });
    }
}


// Plugins to include in the build.
Editor.builtinPlugins = [
    Alignment,
    AutoImage,
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    Code,
    DataFilter,
    DataSchema,
    Essentials,
    FindAndReplace,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    Highlight,
    HorizontalLine,
    HtmlComment,
    HtmlEmbed,
    Image,
    ImageCaption,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    ImageInsert,
    Indent,
    IndentBlock,
    Italic,
    Link,
    List,
    ListStyle,
    MediaEmbed,
    Paragraph,
    PasteFromOffice,
    RemoveFormat,
    SourceEditing,
    Strikethrough,
    Subscript,
    Superscript,
    Table,
    TableCaption,
    TableCellProperties,
    TableProperties,
    TableToolbar,
    TextTransformation,
    Underline,
    WordCount,
    SmallCaps,
//
    SliderInMaterial,
    Spravka,
    Persona,
    SpravkaLeft,
    UpdateMaterial,
    Opros,
    ContactBlock,
    Poll,
    Forma,
    InsertMedic,
    BlockQuoteHard,
    NewBlockquote,
    FormatTextCustom,
    MultiMediaDropDown,
    DropDownInsert,
    DropDownPhotoGroup,
    DropDownPhotoGeneral,
    TextStylesDropDown,
    VrezkaDark,
    VrezkaLight,
    PhotoFullWidth,
    PhotoDivRight,
    PhotoDivLeft,
    TwoPhoto,
    ThreePhoto,
    FourPhoto,
    FivePhoto,
    SixPhoto,
    TwoPhotoGeneral,
    ThreePhotoGeneral,
    FourPhotoGeneral,
    FivePhotoGeneral,
    SixPhotoGeneral,
    // NaPravah,
    GeneralHtmlSupport,
    CustomDiv,
    ShowFotoBank,
    // ShowAnchorContents,
    ShowAnchorContentsAuto,
    ImageCustom,
    ImageCustomVertical,
    // AnchorBlock,
    NewsInText,
    NewsInTextTwo
];

export default Editor;
